import { useContext, useEffect, useState } from "react";
import { FC, HoverProps } from "./typings";
import styles from "./styles.module.scss";
import CloseIcon from "assets/icons/close.svg?react";
import LayoutContext from "contexts/LayoutContext";
import { useNavigate, useParams } from "react-router-dom";

const Elements: FC<HoverProps> = ({
  refWrapper,
  options,
  selectedElements,
  setSelectedElements,
}) => {
  const { filterId, status } = useParams();
  const navigate = useNavigate();
  const [x, setX] = useState(0);
  const [width, setWidth] = useState(0);

  const calculatePosition = () => {
    const position = refWrapper.current.getBoundingClientRect();

    setX(position.x - 8);
    setWidth(position.width + 20);
  };

  const { sizes } = useContext(LayoutContext);

  useEffect(() => {
    calculatePosition();
  }, [sizes]);

  useEffect(() => {
    if (!refWrapper?.current) return;
    calculatePosition();
  }, [refWrapper]);

  const handleClose = () => {
    setSelectedElements([]);
    navigate(`/packages/${filterId}/${status}`);
  };

  return (
    <div
      className={styles.sep}
      style={{
        position: "absolute",
        top: 81,
        left: x,
        opacity: x === 0 ? 0 : 1,
        height: "32px",
        width: width,
      }}
    >
      <div className="flex">
        <div className={styles.selected}>
          Zaznaczono {selectedElements.length}
        </div>
        <div className="flex pl-3">
          {options
            .filter((option) => option.canMultiple)
            .map((option, index) => (
              <option.Icon
                title={option.name}
                onClick={() => {
                  option.callback();
                }}
                className={styles.icone}
                key={index}
              />
            ))}
        </div>
      </div>
      <div>
        <CloseIcon onClick={handleClose} />
      </div>
    </div>
  );
};

export default Elements;
